import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { DialogType, SOChannel, SoStageId, TypeIds } from "../constants/constants";
import { UtilityService } from "./utility.service";

@Injectable({
    providedIn: "root",
})
export class ProductCalculationUtilityService {
    constructor(private utilityService: UtilityService) {}
    
    onProductSelectionComplete(productType: string, purchaseListTB: any[], selectedBundle: any, selectedProducts: any, allTaxRates: any[], taxEnabled, isVisibleRowTax, zipcode?, stateId?, taxSettings?, taxConfig?) {
        let products = [];

        /** individual product is added inside a bundle */
        if (productType == "Bundle") {
            const productList = _.cloneDeep(purchaseListTB);
            productList?.forEach((p) => {
                if (p.id == selectedBundle.id) {
                    const newAdd = selectedProducts?.filter((x) => !p.bundleDetails?.some((y) => y.id == x.id));
                    newAdd?.forEach((prd) => {
                        prd.ordQty = prd.ordQty * p.ordQty * (p.unit?.uomDetail?.value || 1);
                        prd.totalQuantity = prd.ordQty * (prd.unit?.uomDetail?.value || 1);
                    });
                    p.bundleDetails = _.cloneDeep(selectedProducts);
                    if (p.typeId == TypeIds.BundleTypeId) {
                        let total = 0;
                        let taxTotal = 0;
                        p?.bundleDetails?.forEach((bProduct) => {
                            let bProductsSubTaxes = this.utilityService.getProductsApplicableSubTaxes(bProduct, allTaxRates, zipcode, stateId, taxSettings, taxConfig);
                            if(bProduct && bProduct?.bundleDetailSubTax && bProduct?.bundleDetailSubTax?.length > 0){
                                bProductsSubTaxes = bProduct?.bundleDetailSubTax;
                                bProduct['isManualTaxApplied'] = true;
                            }
                            const bSubTotal = Number(bProduct.price) * Number(bProduct.totalQuantity);
                            bProduct.baseSubTotal = bSubTotal;
                            bProduct.totalCostPrice = Number(bProduct.costPrice) * Number(bProduct.totalQuantity);
                            let bProductsTotalTax = 0;
                            if (taxEnabled && isVisibleRowTax) {
                                bProductsSubTaxes?.forEach((sTax) => {
                                    bProductsTotalTax += this.calculateProductsTax(sTax.taxRate, bSubTotal);
                                });
                            }
                            bProduct.subTotal = bSubTotal + bProductsTotalTax;
                            bProduct.taxAmount = bProductsTotalTax;
                            bProduct["bundleDetailSubTax"] = bProductsSubTaxes;
                            total += bProduct.subTotal;
                            taxTotal += bProductsTotalTax;
                        });
                        p.subTotal = total;
                        p.taxAmount = taxTotal;
                    } else if (p.typeId == TypeIds.KitTypeId) {
                        let kitQty = 0;
                        let kitCount = 0;
                        let count = 0;
                        p?.bundleDetails?.forEach((element) => {
                            if (element.typeId == TypeIds.InventoryTypeId || element.typeId == TypeIds.KitTypeId || element.typeId == TypeIds.KitTypeId) {
                                if (count == 0) {
                                    kitQty = Math.floor(element.availabel / (element.originalQty * (element.unit?.uomDetail?.value || 1)));
                                    kitCount = isNaN(kitCount) ? 0 : kitCount;
                                    kitCount = kitQty < 0 ? 0 : kitQty;
                                    count++;
                                } else if (count > 0) {
                                    kitQty = Math.floor(element.availabel / (element.originalQty * (element.unit?.uomDetail?.value || 1)));
                                    kitCount = isNaN(kitCount) ? 0 : kitCount;
                                    kitCount = kitQty <= kitCount && kitQty >= 0 ? kitQty : kitCount;
                                    count++;
                                }
                            }
                        });
                        p.totalAvailInSelectedWareHouse = kitCount;
                        p.availabel = kitCount;
                    }
                }
            });
            products = _.cloneDeep(productList);
        } else {
            /** individual product or bundle is added in products list */
            const productList = _.cloneDeep(selectedProducts);
            productList?.forEach((product) => {
                let subTaxes = this.utilityService.getProductsApplicableSubTaxes(product, allTaxRates, zipcode, stateId, taxSettings, taxConfig);
                if(product && product?.productSubTax && product?.productSubTax?.length > 0){
                    subTaxes = product?.productSubTax;
                    product['isManualTaxApplied'] = true;
                }
                if (!product.subTotal && !product.baseSubTotal) {
                    product.subTotal = 0;
                    product.baseSubTotal = 0;

                    /** inventory & kit items */
                    if (product.typeId != TypeIds.BundleTypeId) {
                        const subTotal = Number(product.price) * Number(product.totalQuantity);
                        product.baseSubTotal = subTotal;
                        product.selectedBin = this.utilityService.setBin(product.totalQuantity, product.binDetails);
                        product.totalCostPrice = Number(product.costPrice) * Number(product.totalQuantity);

                        let productsTotalTax = 0;
                        if (taxEnabled && isVisibleRowTax) {
                            subTaxes?.forEach((sTax) => {
                                productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
                            });
                        }

                        product.subTotal = subTotal + productsTotalTax;
                        product.taxAmount = productsTotalTax;
                        product["productSubTax"] = subTaxes;
                        if (product.bundleDetails?.length > 0) {
                            for (let kp of product.bundleDetails) {
                                kp.show = false;
                                kp.selectedBin = this.utilityService.setBin(kp.totalQuantity, kp.binDetails);
                                for (let kit of kp.bundleDetails) {
                                    kit.selectedBin = this.utilityService.setBin(kit.totalQuantity, kit.binDetails);
                                }
                            }
                        }
                    } else {
                        /** bundle products */
                        let total = 0;
                        let totalOfBaseSubTotal = 0;
                        let taxTotal = 0;
                        product?.bundleDetails?.forEach((bProduct) => {
                            /** bundle products subtaxes will be each inner products subtax */
                            let bProductsSubTaxes = this.utilityService.getProductsApplicableSubTaxes(bProduct, allTaxRates, zipcode, stateId, taxSettings, taxConfig);
                            if(bProduct && bProduct?.bundleDetailSubTax && bProduct?.bundleDetailSubTax?.length > 0){
                                bProductsSubTaxes = bProduct?.bundleDetailSubTax;
                                bProduct['isManualTaxApplied'] = true;
                            }
                            
                            const bSubTotal = Number(bProduct.price) * Number(bProduct.totalQuantity);
                            bProduct.baseSubTotal = bSubTotal;
                            bProduct.totalCostPrice = Number(bProduct.costPrice) * Number(bProduct.totalQuantity);

                            let bProductsTotalTax = 0;
                            if (taxEnabled && isVisibleRowTax) {
                                bProductsSubTaxes?.forEach((sTax) => {
                                    bProductsTotalTax += this.calculateProductsTax(sTax.taxRate, bSubTotal);
                                });
                            }

                            bProduct.subTotal = bSubTotal + bProductsTotalTax;
                            bProduct.selectedBin = this.utilityService.setBin(bProduct.totalQuantity, bProduct.binDetails);
                            bProduct.taxAmount = bProductsTotalTax;
                            bProduct["bundleDetailSubTax"] = bProductsSubTaxes;
                            total += bProduct.subTotal;
                            totalOfBaseSubTotal += bProduct.baseSubTotal;
                            taxTotal += bProductsTotalTax;
                        });
                        product.subTotal = total;
                        product.baseSubTotal = totalOfBaseSubTotal;
                        product.taxAmount = taxTotal;
                    }
                }
                products.push(product);
            });
        }
        return products;
    }

    onProductSearchCompleteByBarcode(data) {
        let productsList = data.products && data.products.length ? _.cloneDeep(data.products) : [];
        data?.newProducts?.forEach((newProduct) => {
            let product = productsList.find((p) => p.id == newProduct.id);
            let total = 0;
            let taxTotal = 0;
            /**
             * If product exists on productsList then need to add new quantity to its ordqty
             * (for Sales Order it can be ordqty, pickqty, packqty based on stage)
             */
            if (product) {
                if (data.channelName == SOChannel.ESTIMATES || data.channelName == SOChannel.INVOICING || (data.channelName == SOChannel.SALES_ORDER && (data.salesOrderStageId == SoStageId.Entered || data.salesOrderStageId == 0))) {
                    product.ordQty = Number(product.ordQty) + Number(newProduct.addQty);
                    product.totalQuantity = product.ordQty;
                } else if (data.channelName == SOChannel.SALES_ORDER && data.salesOrderStageId == SoStageId.Pick) {
                    product.pickedQty = Number(product.pickedQty) + Number(newProduct.addQty);
                    product.totalQuantity = product.pickedQty;
                } else if (data.channelName == SOChannel.SALES_ORDER && (data.salesOrderStageId == SoStageId.Pack || data.salesOrderStageId == SoStageId.Verification || data.salesOrderStageId == SoStageId.Labelling)) {
                    product.packedQty = Number(product.packedQty) + Number(newProduct.addQty);
                    product.totalQuantity = product.packedQty;
                }

                if (product?.typeId == TypeIds.BundleTypeId) {
                    product?.bundleDetails?.forEach((bProduct) => {
                        this.utilityService.addBundleProductsQtyAndCalculateTotal(bProduct, product.totalQuantity, data);
                        bProduct.baseSubTotal = bProduct.subTotal;
                        total += bProduct.subTotal;
                        taxTotal += bProduct.taxAmount;
                    });
                } else if (product?.typeId == TypeIds.KitTypeId) {
                    product?.bundleDetails?.forEach((bProduct) => {
                        this.utilityService.changeProductsQty(bProduct, product.totalQuantity, data);
                    });
                }
                let subTotal = product?.typeId == TypeIds.BundleTypeId ? total : Number(product.price) * Number(product.totalQuantity);
                let productsTotalTax = 0;
                if (product?.typeId != TypeIds.BundleTypeId) {
                    let subTaxes = this.utilityService.getProductsApplicableSubTaxes(product, data.allTaxRates, data.zipCode, data.stateId, data.taxSettings, data.taxConfig);
                    if (data.taxEnabled && data.isVisibleRowTax) {
                        subTaxes?.forEach((sTax) => {
                            productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
                        });
                    }
                    product["productSubTax"] = subTaxes;
                }
                product.baseSubTotal = subTotal;
                product.subTotal = subTotal + productsTotalTax;
                product.taxAmount = productsTotalTax;
            } else {
                /**
                 * If product doesn't exists on productsList then new product should be
                 * added in products list with updated ord qty
                 */
                if (data.channelName == SOChannel.ESTIMATES || data.channelName == SOChannel.INVOICING || (data.channelName == SOChannel.SALES_ORDER && (data.salesOrderStageId == SoStageId.Entered || data.salesOrderStageId == 0))) {
                    newProduct.ordQty = Number(newProduct.addQty);
                    newProduct.totalQuantity = newProduct.ordQty;
                } else if (data.channelName == SOChannel.SALES_ORDER && data.salesOrderStageId == SoStageId.Pick) {
                    newProduct.pickedQty = Number(newProduct.addQty);
                    newProduct.totalQuantity = newProduct.pickedQty;
                } else {
                    newProduct.pickedQty = Number(newProduct.addQty);
                    newProduct.packedQty = Number(newProduct.addQty);
                    newProduct.totalQuantity = newProduct.packedQty;
                }

                if (newProduct?.typeId == TypeIds.BundleTypeId) {
                    newProduct?.bundleDetails?.forEach((bProduct) => {
                        this.utilityService.addBundleProductsQtyAndCalculateTotal(bProduct, newProduct.totalQuantity, data);
                        bProduct.baseSubTotal = bProduct.subTotal;
                        total += bProduct.subTotal;
                        taxTotal += bProduct.taxAmount;
                    });
                } else if (newProduct?.typeId == TypeIds.KitTypeId) {
                    newProduct?.bundleDetails?.forEach((bProduct) => {
                        this.utilityService.changeProductsQty(bProduct, newProduct.totalQuantity, data);
                    });
                }
                let subTotal = newProduct?.typeId == TypeIds.BundleTypeId ? total : Number(newProduct.price) * Number(newProduct.totalQuantity);
                let productsTotalTax = 0;
                if (newProduct?.typeId != TypeIds.BundleTypeId) {
                    let subTaxes = this.utilityService.getProductsApplicableSubTaxes(newProduct, data.allTaxRates, data.zipCode, data.stateId, data.taxSettings, data.taxConfig);
                    if (data.taxEnabled && data.isVisibleRowTax) {
                        subTaxes?.forEach((sTax) => {
                            productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
                        });
                    }
                    newProduct["productSubTax"] = subTaxes;
                }
                newProduct.baseSubTotal = subTotal;
                newProduct.subTotal = subTotal + productsTotalTax;
                newProduct.taxAmount = productsTotalTax;

                if (data.channelName == SOChannel.ESTIMATES || data.channelName == SOChannel.INVOICING || (data.channelName == SOChannel.SALES_ORDER && (data.salesOrderStageId == SoStageId.Entered || data.salesOrderStageId == 0))) {
                    productsList.push(newProduct);
                }
            }
        });
        return productsList;
    }

    calculateProductsSubTotal(data) {
        data.product.subTotal = 0;

        if (data.product.typeId == TypeIds.KitTypeId) {
            this.calculateKitProductsSubTotal(data);
        }

        if (data?.product.typeId != TypeIds.BundleTypeId) {
            let subTotal = Number(data.product.totalQuantity) * Number(data.product.price);
            data.product.baseSubTotal = Number(data.product.totalQuantity) * Number(data.product.price);

            let appliedDiscount = null;
            if(data?.isRowWiseDiscountEnabled) {
                appliedDiscount = data.allDiscounts?.find((discount) => discount.id == data.discountTypeId);
            }
            if (appliedDiscount && appliedDiscount.isTaxable) {
                this.calculateTaxableDiscountOrderTotal(data, subTotal);
            } else {
                this.calculateNonTaxableDiscountOrderTotal(data, subTotal);
            }
        }
    }

    private calculateKitProductsSubTotal(data) {
        data.product.subTotal = 0;
        const uomValue = data.product?.unit?.uomDetail?.value || 1;

        data?.product?.bundleDetails?.forEach((prd) => {
            prd.subTotal = 0;
            if (data?.dialogType == DialogType.CREATE) {
                prd.ordQty = Number(data.product.ordQty) * Number(prd.originalQty) * Number(uomValue);
            } else {
                prd.ordQty = Number(data.product.ordQty) * Number(prd.originalQty) * Number(uomValue);
            }
            prd.totalQuantity = Number(prd.ordQty) * Number(prd.unit?.uomDetail?.value || 1);
            if (prd.accountPriceTier?.length > 0 && !data.isConvertedFromEstimate) {
                prd.price = this.applyPriceBook(data.aggregateDiscount, prd, prd.totalQuantity);
            }
            //kit/bundle under kit
            prd?.bundleDetails?.forEach((kp) => {
                const uomValueChild = prd?.unit?.uomDetail?.value || 1;
                kp.subTotal = 0;
                if (data?.dialogType == DialogType.CREATE) {
                    kp.ordQty = Number(data.product.ordQty) * Number(kp.originalQty) * Number(uomValueChild) * Number(uomValue);
                } else {
                    kp.ordQty = Number(data.product.ordQty) * Number(kp.originalQty) * Number(uomValueChild) * Number(uomValue);
                }
                kp.totalQuantity = Number(kp.ordQty) * Number(kp.unit?.uomDetail?.value || 1);
                if (kp.accountPriceTier?.length > 0 && !data.isConvertedFromEstimate) {
                    kp.price = this.applyPriceBook(data.aggregateDiscount, kp, kp.totalQuantity);
                }
                if(data?.isRowWiseDiscountEnabled) {
                    let discount = this.calculateProductsDiscount(kp?.discountType, kp.totalQuantity, kp.price, kp.discount);
                    kp.discountAmount = discount;
                }
                kp.subTotal = Number(kp.subTotal) - Number(kp.discountAmount);
                prd.subTotal = prd.subTotal + kp.subTotal;
            });
            if(data?.isRowWiseDiscountEnabled) {
                let discount = this.calculateProductsDiscount(prd?.discountType, prd.totalQuantity, prd.price, prd.discount);
                prd.discountAmount = discount;
            }
            prd.subTotal = Number(prd.subTotal) - Number(prd.discountAmount);
            data.product.subTotal = data.product.subTotal + prd.subTotal;
        });
    }

    private calculateTaxableDiscountOrderTotal(data, subTotal) {
        // discount
        if(data?.isRowWiseDiscountEnabled) {
            let discount = this.calculateProductWiseDiscount(data.product?.discountType, subTotal, data.product.discount);
            data.product.discountAmount = discount;
            data.product.subTotal = Number(subTotal) - Number(discount);
        }

        // additional fee
        if (data.isRowWiseAdditionalFeeEnabled && data?.product?.additionalFeeType?.isTaxable) {
            let addFee = this.calculateProductWiseAdditionalFee(data?.product?.additionalFeeType?.type?.name, data.product.subTotal, data?.product?.additionalFee);
            data.product.additionalFeeAmount = addFee;
            data.product.subTotal = data.product.subTotal + Number(addFee);
        }

        // tax
        let productsTotalTax = 0;
        if (data?.taxEnabled && data?.isEnabledRowTax) {
            data?.product?.productSubTax?.forEach((sTax) => {
                productsTotalTax += this.calculateProductsTax(sTax.taxRate, data.product.subTotal);
            });

            if(data?.product?.hasOwnProperty('bundleDetailSubTax') && data?.product?.bundleDetailSubTax?.length > 0) {
                data?.product?.bundleDetailSubTax?.forEach((sTax) => {
                    productsTotalTax += this.calculateProductsTax(sTax.taxRate, data.product.subTotal);
                });
            }
        }
        data.product.subTotal = data.product.subTotal + productsTotalTax;
        data.product.taxAmount = productsTotalTax;

        // additional fee
        if (data.isRowWiseAdditionalFeeEnabled && !data?.product?.additionalFeeType?.isTaxable) {
            let addFee = this.calculateProductWiseAdditionalFee(data?.product?.additionalFeeType?.type?.name, data.product.subTotal, data?.product?.additionalFee);
            data.product.additionalFeeAmount = addFee;
            data.product.subTotal = data.product.subTotal + Number(addFee);
        }
    }

    private calculateNonTaxableDiscountOrderTotal(data, subTotal) {
        // additional fee
        if (data.isRowWiseAdditionalFeeEnabled && data?.product?.additionalFeeType?.isTaxable) {
            let addFee = this.calculateProductWiseAdditionalFee(data?.product?.additionalFeeType?.type?.name, subTotal, data?.product?.additionalFee);
            data.product.additionalFeeAmount = addFee;
            subTotal = subTotal + Number(addFee);
        }

        // tax
        let productsTotalTax = 0;
        if (data?.taxEnabled && data?.isEnabledRowTax) {
            data?.product?.productSubTax?.forEach((sTax) => {
                productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
            });

            if(data?.product?.hasOwnProperty('bundleDetailSubTax') && data?.product?.bundleDetailSubTax?.length > 0) {
                data?.product?.bundleDetailSubTax?.forEach((sTax) => {
                    productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
                });
            }
        }
        data.product.subTotal = subTotal + productsTotalTax;
        data.product.taxAmount = productsTotalTax;

        // discount
        if(data?.isRowWiseDiscountEnabled) {
            let discount = this.calculateProductWiseDiscount(data.product?.discountType, data.product.subTotal, data.product.discount);
            data.product.discountAmount = discount;
            data.product.subTotal = Number(data.product.subTotal) - Number(discount);
        }

        // additional fee
        if (data.isRowWiseAdditionalFeeEnabled && !data?.product?.additionalFeeType?.isTaxable) {
            let addFee = this.calculateProductWiseAdditionalFee(data?.product?.additionalFeeType?.type?.name, data.product.subTotal, data?.product?.additionalFee);
            data.product.additionalFeeAmount = addFee;
            data.product.subTotal = data.product.subTotal + Number(addFee);
        }
    }

    private calculateProductsDiscount(disType: any, totalQty: number, price: number, discount: number) {
        let discountAmount = 0;
        if (price == 0) {
            return discountAmount;
        }
        if (disType) {
            if (disType.description == "%" || disType.description?.toLowerCase() == "percentage") {
                discountAmount = (Number(totalQty) * Number(price) * Number(discount)) / 100;
            } else if (disType.description == "$" || disType.description?.toLowerCase() == "amount") {
                discountAmount = discount;
            }
        }
        return discountAmount;
    }

    private calculateProductWiseDiscount(disType: any, subTotal: number, discount: number) {
        let discountAmount = 0;
        if (subTotal == 0) {
            return discountAmount;
        }
        if (disType) {
            if (disType.description == "%" || disType.description?.toLowerCase() == "percentage") {
                discountAmount = subTotal * (Number(discount) / 100);
            } else if (disType.description == "$" || disType.description?.toLowerCase() == "amount") {
                discountAmount = discount;
            }
        }
        return discountAmount;
    }

    private calculateProductWiseAdditionalFee(feeType: any, subTotal: number, fee: number) {
        let additionalFeeAmount = 0;
        if (feeType) {
            if (feeType == "%" || feeType?.toLowerCase() == "percentage") {
                additionalFeeAmount = subTotal * (Number(fee) / 100);
            } else if (feeType == "$" || feeType?.toLowerCase() == "amount") {
                additionalFeeAmount = fee;
            }
        }
        return additionalFeeAmount;
    }

    private calculateProductsTax(taxRate: number, subTotal: number) {
        return subTotal * (Number(taxRate) / 100);
    }

    private applyPriceBook(aggregateDiscount, item, qty) {
        if (!item.isCustom) {
            if (aggregateDiscount) {
                /**
                 * Set Aggregate Discount.
                 */
                if (!item.isCustom && item.accountPriceTier?.length > 1) {
                    if (item.discountTypeName == "Discount By Product Group") {
                        const qtyTier = item.accountPriceTier?.filter((tier) => tier.tierId != item.selectedTierId)[0];
                        item.price = Number(this.setPricePerQty(qtyTier, qty));
                        const group = item.accountPriceTier?.filter((tier) => tier.tierId == item.selectedTierId)[0];
                        const groupDiscount = Number(item.price * (group?.markUp / 100));
                        item.price = item.price + (isNaN(groupDiscount) ? 0 : groupDiscount);
                        return item.price;
                    } else if (item.discountTypeName == "Discount By Qty") {
                        const selectedAccountTier = item.accountPriceTier?.filter((tier) => tier.tierId == item.selectedTierId)[0];
                        item.price = Number(this.setPricePerQty(selectedAccountTier, qty));
                        const group = item.accountPriceTier?.filter((tier) => tier.tierId != item.selectedTierId)[0];
                        const groupDiscount = Number(item.price * (group?.markUp / 100));
                        item.price = item.price + (isNaN(groupDiscount) ? 0 : groupDiscount);
                        return item.price;
                    }
                } else if (!item.isCustom && item.accountPriceTier?.length == 1) {
                    //Either Tier Or Group
                    const selectedAccountTier = item.accountPriceTier?.filter((tier) => tier.tierId == item.selectedTierId)[0];
                    item.price = selectedAccountTier?.qtyPrice?.length > 0 ? this.setPricePerQty(selectedAccountTier, qty) : item.price;
                    return item.price;
                }
            } else {
                /**
                 * Set Price Per Product based on Ordered Qty and Product Pricebook.
                 */
                if (!item.isCustom && item.accountPriceTier?.length > 1) {
                    let tierPrice;
                    let groupPrice;
                    if (item.discountTypeName == "Discount By Product Group") {
                        groupPrice = Number(qty * item.originalprice);
                        const qtyTier = item.accountPriceTier?.filter((tier) => tier.tierId != item.selectedTierId)[0];
                        tierPrice = qtyTier?.qtyPrice?.length > 0 && Number(qty * this.setPricePerQty(qtyTier, qty));
                    } else if (item.discountTypeName == "Discount By Qty") {
                        const selectedAccountTier = item.accountPriceTier?.filter((tier) => tier.tierId == item.selectedTierId)[0];
                        tierPrice = Number(qty * this.setPricePerQty(selectedAccountTier, qty));
                        const group = item.accountPriceTier?.filter((tier) => tier.tierId != item.selectedTierId)[0];
                        groupPrice = Number(qty * group.calculatedPricePerQty);
                    }
                    //Apply discount Type based on minimum pricePerProduct
                    if (groupPrice > tierPrice) {
                        item.price = isNaN(Number(tierPrice / qty)) ? item.price : Number(tierPrice / qty);
                        return item.price;
                    } else {
                        item.price = isNaN(Number(groupPrice / qty)) ? item.price : Number(groupPrice / qty);
                        return item.price;
                    }
                } else if (!item.isCustom && item.accountPriceTier?.length == 1) {
                    //Either Tier Or Group
                    const selectedAccountTier = item.accountPriceTier?.filter((tier) => tier.tierId == item.selectedTierId)[0];
                    item.price = selectedAccountTier?.qtyPrice?.length > 0 ? this.setPricePerQty(selectedAccountTier, qty) : item.price;
                    return item.price;
                }
            }
        } else {
            return item.price;
        }
    }

    private setPricePerQty(tier, qty) {
        if (qty < tier.qtyPrice[1]?.qty) {
            return tier.qtyPrice[0].price;
        } else if (qty > tier.qtyPrice[1]?.qty - 1 && qty < tier.qtyPrice[2]?.qty) {
            return tier.qtyPrice[1].price;
        } else if (qty > tier.qtyPrice[2]?.qty - 1 && qty < tier.qtyPrice[3]?.qty) {
            return tier.qtyPrice[2].price;
        } else if (qty > tier.qtyPrice[3]?.qty - 1 && qty < tier.qtyPrice[4]?.qty) {
            return tier.qtyPrice[3].price;
        } else if (qty > tier.qtyPrice[4]?.qty - 1 && qty < tier.qtyPrice[5]?.qty) {
            return tier.qtyPrice[4].price;
        } else if (qty >= tier.qtyPrice[5]?.qty) {
            return tier.qtyPrice[5]?.price;
        } else {
            return tier.qtyPrice[tier.qtyPrice?.length - 1]?.price;
        }
    }

    calculateQtyAndBundleProductsSubTotal(item, qty, allTaxRates, channelName, dialogType, taxEnabled, isVisibleRowTax, data?) {
        let total = 0;
        let totalOfBaseSubTotal = 0;
        let taxTotal = 0;
        if (item?.bundleDetails?.length > 0) {
            item?.bundleDetails?.forEach((e) => {
                const uomValue = e?.unit?.uomDetail?.value || 1;

                if (channelName == SOChannel.SALES_ORDER) {
                    if (data.stageId == SoStageId.Entered) {
                        if (dialogType == DialogType.CREATE) {
                            e.ordQty = Number(e.originalQty) * Number(qty) * Number(item.unit?.uomDetail?.value || 1);
                        } else {
                            e.ordQty = Number(e.originalQty) * Number(qty) * Number(item.unit?.uomDetail?.value || 1);
                        }
                        e.totalQuantity = Number(e.ordQty) * Number(uomValue);

                        // Pricebook
                        if (e.accountPriceTier?.length > 0 && !data.soDetails?.isConvertedFromEstimate) {
                            e.price = this.applyPriceBook(data.aggregateDiscount, e, e.totalQuantity);
                        }
                    } else if (data.stageId == SoStageId.Pick) {
                        e.pickedQty = Number(qty) * Number(e.originalQty) * Number(item.unit?.uomDetail?.value || 1);
                        e.totalQuantity = Number(e.pickedQty) * Number(uomValue);
                    } else {
                        e.packedQty = Number(qty) * Number(e.originalQty) * Number(item.unit?.uomDetail?.value || 1);
                        e.totalQuantity = Number(e.packedQty) * Number(uomValue);
                    }
                } else {
                    const uomValue = e?.unit?.uomDetail?.value || 1;
                    if (dialogType == DialogType.CREATE) {
                        e.ordQty = Number(e.originalQty) * Number(qty) * Number(item.unit?.uomDetail?.value || 1);
                    } else {
                        e.ordQty = Number(e.originalQty) * Number(qty) * Number(item.unit?.uomDetail?.value || 1);
                    }
                    e.totalQuantity = Number(e.ordQty) * Number(uomValue);

                    //Pricebook
                    if (e.accountPriceTier?.length > 0) {
                        e.price = this.applyPriceBook(data.aggregateDiscount, e, e.totalQuantity);
                    }
                }

                // tax
                let subTotal = Number(e.totalQuantity) * Number(e.price);
                e.baseSubTotal = subTotal;
                e.totalCostPrice = Number(e.totalQuantity) * Number(e.costPrice);

                /** Tax and Discount */
                let appliedDiscount = null;
                if(data?.isRowWiseDiscountEnabled) {
                    appliedDiscount = data.allDiscounts?.find((discount) => discount.id == e.discountId);
                }
                /** If checked, sale tax will be calculated on the order total after discount has been applied. */
                if (appliedDiscount && appliedDiscount.isTaxable) {
                    if(data?.isRowWiseDiscountEnabled) {
                        let discount = this.calculateProductWiseDiscount(e?.discountType, subTotal, e.discount);
                        e.discountAmount = discount;
                        e.subTotal = Number(subTotal) - Number(discount);
                    }
                    // additional fee
                    if (data.isRowWiseAdditionalFeeEnabled && e?.additionalFeeType?.isTaxable) {
                        let addFee = this.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, e.subTotal, e.additionalFee);
                        e.additionalFeeAmount = addFee;
                        e.subTotal = e.subTotal + Number(addFee);
                    }
                    let productsTotalTax = 0;
                    if (data?.taxEnabled && data?.isEnabledRowTax) {
                        e?.bundleDetailSubTax?.forEach((sTax) => {
                            productsTotalTax += this.calculateProductsTax(sTax.taxRate, e.subTotal);
                        });
                    }
                    e.subTotal = e.subTotal + productsTotalTax;
                    e.taxAmount = productsTotalTax;
                    // additional fee
                    if (data.isRowWiseAdditionalFeeEnabled && !e?.additionalFeeType?.isTaxable) {
                        let addFee = this.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, e.subTotal, e.additionalFee);
                        e.additionalFeeAmount = addFee;
                        e.subTotal = e.subTotal + Number(addFee);
                    }
                    taxTotal += productsTotalTax;
                } else {
                    // additional fee
                    if (data.isRowWiseAdditionalFeeEnabled && e?.additionalFeeType?.isTaxable) {
                        let addFee = this.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, subTotal, e.additionalFee);
                        e.additionalFeeAmount = addFee;
                        subTotal = subTotal + Number(addFee);
                    }
                    let productsTotalTax = 0;
                    if (data?.taxEnabled && data?.isEnabledRowTax) {
                        e?.bundleDetailSubTax?.forEach((sTax) => {
                            productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
                        });
                    }
                    e.subTotal = subTotal + productsTotalTax;
                    e.taxAmount = productsTotalTax;

                    if(data?.isRowWiseDiscountEnabled) {
                        let discount = this.calculateProductWiseDiscount(e?.discountType, e.subTotal, e.discount);
                        e.discountAmount = discount;
                        e.subTotal = Number(e.subTotal) - Number(discount);
                    }

                    // additional fee
                    if (data.isRowWiseAdditionalFeeEnabled && !e?.additionalFeeType?.isTaxable) {
                        let addFee = this.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, e.subTotal, e.additionalFee);
                        e.additionalFeeAmount = addFee;
                        e.subTotal = e.subTotal + Number(addFee);
                    }
                    taxTotal += productsTotalTax;
                }

                total += e.subTotal;
                totalOfBaseSubTotal += e.baseSubTotal;
            });
            item.price = total;
            item.subTotal = total;
            item.baseSubTotal = totalOfBaseSubTotal;
            item.taxAmount = taxTotal;
        }
    }

    calculateBundleProductSubtotal(data) {
        if (data?.bundle.typeId == TypeIds.BundleTypeId) {
            data?.bundle?.bundleDetails?.forEach((e) => {
                if (e.id == data?.product.id) {
                    const uomValue = e?.unit?.uomDetail?.value || 1;
                    if (data?.channelName == SOChannel.SALES_ORDER) {
                        e.totalQuantity = data?.stageId == SoStageId.Entered ? Number(e.ordQty) * Number(uomValue) : data?.stageId == SoStageId.Pick ? Number(e.pickedQty) * Number(uomValue) : Number(e.packedQty) * Number(uomValue);
                    } else {
                        e.totalQuantity = Number(e.ordQty) * Number(uomValue);
                    }
                    //Pricebook
                    if (data?.type == "qty" && e.accountPriceTier?.length > 0 && !data?.isConvertedFromEstimate) {
                        e.price = this.applyPriceBook(data?.aggregateDiscount, e, Number(e.ordQty) * Number(uomValue));
                    }

                    let subTotal = Number(e.totalQuantity) * Number(e.price);
                    e.baseSubTotal = subTotal;
                    /** Tax and Discount */
                    let appliedDiscount = null;
                    if(data?.isRowWiseDiscountEnabled) {
                        appliedDiscount = data.allDiscounts?.find((discount) => discount.id == data.discountTypeId);
                    }
                    /** If checked, sale tax will be calculated on the order total after discount has been applied. */
                    if (appliedDiscount && appliedDiscount.isTaxable) {
                        if(data?.isRowWiseDiscountEnabled) {
                            let discount = this.calculateProductWiseDiscount(e?.discountType, subTotal, e.discount);
                            e.discountAmount = discount;
                            e.subTotal = Number(subTotal) - Number(discount);
                        }

                        // additional fee
                        if (data.isRowWiseAdditionalFeeEnabled && e?.additionalFeeType?.isTaxable) {
                            let addFee = this.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, e.subTotal, e.additionalFee);
                            e.additionalFeeAmount = addFee;
                            e.subTotal = e.subTotal + Number(addFee);
                        }

                        let productsTotalTax = 0;
                        if (data?.taxEnabled && data?.isVisibleRowTax) {
                            e?.bundleDetailSubTax?.forEach((sTax) => {
                                productsTotalTax += this.calculateProductsTax(sTax.taxRate, e.subTotal);
                            });
                        }
                        e.subTotal = e.subTotal + productsTotalTax;
                        e.taxAmount = productsTotalTax;
                        // additional fee
                        if (data.isRowWiseAdditionalFeeEnabled && !e?.additionalFeeType?.isTaxable) {
                            let addFee = this.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, e.subTotal, e.additionalFee);
                            e.additionalFeeAmount = addFee;
                            e.subTotal = e.subTotal + Number(addFee);
                        }
                    } else {
                        // additional fee
                        if (data.isRowWiseAdditionalFeeEnabled && e?.additionalFeeType?.isTaxable) {
                            let addFee = this.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, subTotal, e.additionalFee);
                            e.additionalFeeAmount = addFee;
                            subTotal = subTotal + Number(addFee);
                        }
                        let productsTotalTax = 0;
                        if (data?.taxEnabled && data?.isVisibleRowTax) {
                            e?.bundleDetailSubTax?.forEach((sTax) => {
                                productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
                            });
                        }
                        e.subTotal = subTotal + productsTotalTax;
                        e.taxAmount = productsTotalTax;

                        if(data?.isRowWiseDiscountEnabled) {
                            let discount = this.calculateProductWiseDiscount(e?.discountType, e.subTotal, e.discount);
                            e.discountAmount = discount;
                            e.subTotal = Number(e.subTotal) - Number(discount);
                        }

                        // additional fee
                        if (data.isRowWiseAdditionalFeeEnabled && !e?.additionalFeeType?.isTaxable) {
                            let addFee = this.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, e.subTotal, e.additionalFee);
                            e.additionalFeeAmount = addFee;
                            e.subTotal = e.subTotal + Number(addFee);
                        }
                    }
                }
            });
            // total of all products is the total of that bundle
            let total = 0;
            let totalOfBaseSubTotal = 0;
            let taxTotal = 0;
            data?.bundle?.bundleDetails?.forEach((e) => {
                total += Number(e.subTotal);
                totalOfBaseSubTotal += Number(e.baseSubTotal);
                taxTotal += Number(e.taxAmount);
            });
            data.bundle.price = total;
            data.bundle.subTotal = total;
            data.bundle.baseSubTotal = totalOfBaseSubTotal;
            data.bundle.taxAmount = taxTotal;
        }
    }

    calculateSalesOrderProductsSubTotal(product, dialogType, allTaxRates, channelName, aggregateDiscount, isEnabledRowTax, taxEnabled, stageId, isConvertedFromEstimate, isOrderToBeShipped, stateId, zipCode, taxSettings, taxConfig, allDiscounts, discountTypeId, isRowWiseAdditionalFeeEnabled, isRowWiseDiscountEnabled) {
        const uomValue = product?.unit?.uomDetail?.value || 1;

        /**
         * If product type is kit and parent items ordqty is changed
         * that should reflect in inner products ordqty
         *
         */
        if (product.typeId == TypeIds.KitTypeId) {
            product.subTotal = 0;
            if (channelName == SOChannel.SALES_ORDER) {
                let kitQty = 0;
                let kitCount = 0;
                let count = 0;
                product?.bundleDetails?.forEach((prd) => {
                    prd.subTotal = 0;
                    prd.baseSubTotal = 0;
                    if (prd.bundleDetails?.length > 0) {
                        const buomValue = prd?.unit?.uomDetail?.value || 1;
                        prd?.bundleDetails?.forEach((kp) => {
                            kp.subTotal = 0;
                            kp.baseSubTotal = 0;

                            if (isOrderToBeShipped) {
                                kp.packedQty = Number(product.packedQty) * Number(kp.originalQty) * Number(uomValue) * Number(buomValue);
                                kp.totalQuantity = Number(kp.packedQty) * Number(kp.unit?.uomDetail?.value || 1);
                                kp.subTotal = kp.totalQuantity * kp.price + Number(kp.taxAmount);
                                kp.baseSubTotal = kp.totalQuantity * kp.price;
                            } else if (stageId == SoStageId.Entered) {
                                if (dialogType == DialogType.CREATE) {
                                    kp.ordQty = Number(product.ordQty) * Number(kp.originalQty) * Number(uomValue) * Number(buomValue);
                                    kp.totalQuantity = Number(kp.ordQty) * Number(kp.unit?.uomDetail?.value || 1);
                                } else {
                                    kp.ordQty = Number(product.ordQty) * Number(kp.originalQty) * Number(uomValue) * Number(buomValue);
                                    kp.totalQuantity = Number(kp.ordQty) * Number(kp.unit?.uomDetail?.value || 1);
                                }
                                if (kp.accountPriceTier?.length > 0 && !isConvertedFromEstimate) {
                                    kp.price = this.applyPriceBook(aggregateDiscount, kp, kp.totalQuantity);
                                }
                                kp.subTotal = kp.totalQuantity * kp.price + Number(kp.taxAmount);
                                kp.baseSubTotal = kp.totalQuantity * kp.price;
                            } else if (stageId == SoStageId.Pick) {
                                kp.pickedQty = Number(product.pickedQty) * Number(kp.originalQty) * Number(uomValue) * Number(buomValue);
                                kp.totalQuantity = Number(kp.pickedQty) * Number(kp.unit?.uomDetail?.value || 1);
                                kp.subTotal = kp.totalQuantity * kp.price + Number(kp.taxAmount);
                                kp.baseSubTotal = kp.totalQuantity * kp.price;
                            } else {
                                kp.packedQty = Number(product.packedQty) * Number(kp.originalQty) * Number(uomValue) * Number(buomValue);
                                kp.totalQuantity = Number(kp.packedQty) * Number(kp.unit?.uomDetail?.value || 1);
                                kp.subTotal = kp.totalQuantity * kp.price + Number(kp.taxAmount);
                                kp.baseSubTotal = kp.totalQuantity * kp.price;
                            }

                            if(isRowWiseDiscountEnabled) {
                                let discount = this.calculateProductsDiscount(kp?.discountType, kp.totalQuantity, kp.price, kp.discount);
                                kp.discountAmount = discount;
                                kp.subTotal = Number(kp.subTotal) - Number(discount);
                            }
                            prd.subTotal = prd.subTotal + kp.subTotal;
                        });
                    }
                    if (isOrderToBeShipped) {
                        prd.packedQty = Number(product.packedQty) * Number(prd.originalQty) * Number(uomValue);
                        prd.totalQuantity = Number(prd.packedQty) * Number(prd.unit?.uomDetail?.value || 1);
                        prd.subTotal = prd.totalQuantity * prd.price + Number(prd.taxAmount);
                        prd.baseSubTotal = prd.totalQuantity * prd.price;
                    } else if (stageId == SoStageId.Entered) {
                        if (dialogType == DialogType.CREATE) {
                            prd.ordQty = Number(product.ordQty) * Number(prd.originalQty) * Number(uomValue);
                            prd.totalQuantity = Number(prd.ordQty) * Number(prd.unit?.uomDetail?.value || 1);
                        } else {
                            prd.ordQty = Number(product.ordQty) * Number(prd.originalQty) * Number(uomValue);
                            prd.totalQuantity = Number(prd.ordQty) * Number(prd.unit?.uomDetail?.value || 1);
                        }
                        if (prd.accountPriceTier?.length > 0 && !isConvertedFromEstimate) {
                            prd.price = this.applyPriceBook(aggregateDiscount, prd, prd.totalQuantity);
                        }
                        prd.subTotal = prd.totalQuantity * prd.price + Number(prd.taxAmount);
                        prd.baseSubTotal = prd.totalQuantity * prd.price;
                    } else if (stageId == SoStageId.Pick) {
                        prd.pickedQty = Number(product.pickedQty) * Number(prd.originalQty) * Number(uomValue);
                        prd.totalQuantity = Number(prd.pickedQty) * Number(prd.unit?.uomDetail?.value || 1);
                        prd.subTotal = prd.totalQuantity * prd.price + Number(prd.taxAmount);
                        prd.baseSubTotal = prd.totalQuantity * prd.price;
                    } else {
                        prd.packedQty = Number(product.packedQty) * Number(prd.originalQty) * Number(uomValue);
                        prd.totalQuantity = Number(prd.packedQty) * Number(prd.unit?.uomDetail?.value || 1);
                        prd.subTotal = prd.totalQuantity * prd.price + Number(prd.taxAmount);
                        prd.baseSubTotal = prd.totalQuantity * prd.price;
                    }

                    if (prd.typeId == TypeIds.InventoryTypeId || prd.typeId == TypeIds.KitTypeId || prd.typeId == TypeIds.BundleTypeId) {
                        if (count == 0) {
                            kitQty = Math.floor(prd.availabel / (prd.originalQty * (prd.unit?.uomDetail?.value || 1)));
                            kitCount = isNaN(kitCount) ? 0 : kitCount;
                            kitCount = kitQty < 0 ? 0 : kitQty;
                            count++;
                        } else if (count > 0) {
                            kitQty = Math.floor(prd.availabel / (prd.originalQty * (prd.unit?.uomDetail?.value || 1)));
                            kitCount = isNaN(kitCount) ? 0 : kitCount;
                            kitCount = kitQty <= kitCount && kitQty >= 0 ? kitQty : kitCount;
                            count++;
                        }
                    }

                    if(isRowWiseDiscountEnabled) {
                        let discount = this.calculateProductsDiscount(prd?.discountType, prd.totalQuantity, prd.price, prd.discount);
                        prd.discountAmount = discount;
                        prd.subTotal = Number(prd.subTotal) - Number(discount);
                    }
                    product.subTotal = product.subTotal + prd.subTotal;
                });
                product.totalAvailInSelectedWareHouse = kitCount;
                product.availabel = kitCount;
            } else {
                product?.bundleDetails?.forEach((prd) => {
                    prd.subTotal = 0;
                    prd.baseSubTotal = 0;
                    if (dialogType == DialogType.CREATE) {
                        prd.ordQty = Number(product.ordQty) * Number(prd.originalQty) * Number(uomValue);
                    } else {
                        prd.ordQty = Number(product.ordQty) * Number(prd.originalQty) * Number(uomValue);
                    }
                    prd.totalQuantity = Number(prd.ordQty) * Number(prd.unit?.uomDetail?.value || 1);
                    if (prd.accountPriceTier?.length > 0 && !isConvertedFromEstimate) {
                        prd.price = this.applyPriceBook(aggregateDiscount, prd, prd.totalQuantity);
                    }

                    if(isRowWiseDiscountEnabled) {
                        let discount = this.calculateProductsDiscount(prd?.discountType, prd.totalQuantity, prd.price, prd.discount);
                        prd.discountAmount = discount;
                        prd.subTotal = Number(prd.subTotal) - Number(discount);
                    }
                    product.subTotal = product.subTotal + prd.subTotal;
                });
            }
        }

        if (product.typeId != TypeIds.BundleTypeId) {
            product.subTotal = 0;
            let subTotal = Number(product.totalQuantity) * Number(product.price);
            product.baseSubTotal = subTotal;

            /** Tax and Discount */
            let appliedDiscount = null;

            if(isRowWiseDiscountEnabled) {
                appliedDiscount = allDiscounts?.find((discount) => discount.id == discountTypeId);
            }
            if (appliedDiscount && appliedDiscount.isTaxable) {

                if(isRowWiseDiscountEnabled) {
                    let discount = this.calculateProductWiseDiscount(product?.discountType, subTotal, product.discount);
                    product.discountAmount = discount;
                    product.subTotal = Number(subTotal) - Number(discount);
                }

                // taxable additional fee
                if (isRowWiseAdditionalFeeEnabled && product?.additionalFeeType?.isTaxable) {
                    let addFee = this.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, product.subTotal, product?.additionalFee);
                    product.additionalFeeAmount = addFee;
                    product.subTotal = product.subTotal + Number(addFee);
                }

                let productsTotalTax = 0;
                if (taxEnabled && isEnabledRowTax) {
                    product?.productSubTax?.forEach((sTax) => {
                        productsTotalTax += this.calculateProductsTax(sTax.taxRate, product.subTotal);
                    });

                    if(product?.hasOwnProperty('bundleDetailSubTax') && product?.bundleDetailSubTax?.length > 0) {
                        product?.bundleDetailSubTax?.forEach((sTax) => {
                            productsTotalTax += this.calculateProductsTax(sTax.taxRate, product.subTotal);
                        });
                    }
                }
                product.subTotal = product.subTotal + productsTotalTax;
                product.taxAmount = productsTotalTax;

                // not taxable additional fee
                if (isRowWiseAdditionalFeeEnabled && !product?.additionalFeeType?.isTaxable) {
                    let addFee = this.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, product.subTotal, product?.additionalFee);
                    product.additionalFeeAmount = addFee;
                    product.subTotal = product.subTotal + Number(addFee);
                }
            } else {
                // taxable additional fee
                if (isRowWiseAdditionalFeeEnabled && product?.additionalFeeType?.isTaxable) {
                    let addFee = this.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, subTotal, product?.additionalFee);
                    product.additionalFeeAmount = addFee;
                    subTotal = subTotal + Number(addFee);
                }

                let productsTotalTax = 0;
                if (taxEnabled && isEnabledRowTax) {
                    product?.productSubTax?.forEach((sTax) => {
                        productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
                    });

                    if(product?.hasOwnProperty('bundleDetailSubTax') && product?.bundleDetailSubTax?.length > 0) {
                        product?.bundleDetailSubTax?.forEach((sTax) => {
                            productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
                        });
                    }
                }
                product.subTotal = subTotal + productsTotalTax;
                product.taxAmount = productsTotalTax;

                if(isRowWiseDiscountEnabled) {
                    let discount = this.calculateProductWiseDiscount(product?.discountType, product.subTotal, product.discount);
                    product.discountAmount = discount;
                    product.subTotal = Number(product.subTotal) - Number(discount);
                }

                // not taxable additional fee
                if (isRowWiseAdditionalFeeEnabled && !product?.additionalFeeType?.isTaxable) {
                    let addFee = this.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, product.subTotal, product?.additionalFee);
                    product.additionalFeeAmount = addFee;
                    product.subTotal = product.subTotal + Number(addFee);
                }
            }
        }
    }
}
